/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmEventsV1TargetEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_EVENTS_V1_TARGET_EVENT_ENTITY_NAME = 'ixm.events.v1.TargetEvent';
export const ixmEventsV1TargetEventEntity = new schema.Entity<IxmEventsV1TargetEvent>(IXM_EVENTS_V1_TARGET_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmEventsV1TargetEvent) => `${entity.metadata?.eventId}` });

